import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const WOODSTATEMENT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.WoodStatement.Name')
    .required()
    .maxLength(50)
    .build(),
];

export const WOODSTATEMENT_CONFIG = {
  entityName: 'WoodStatement',
  localizationKey: 'Planning::Entity.WoodStatement',
  fields: WOODSTATEMENT_FIELDS,
  permission: 'Planning.WoodStatements',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Certification + MENU_NAME_SUFFIX,
};
